// src/stores/common/tariff.js
import { ref } from "vue";
import { defineStore } from "pinia";
import apiClient from "@/axios";
import { useToast } from "vue-toastification";

export const usetariffStore = defineStore("Tariff", () => {
    const tariffEntity = ref([]);
    const loading = ref(false);
    const toast = useToast();

    async function fetchtariff() {
        loading.value = true;
        try {
            const response = await apiClient.get(`/Tariff/GetAllAsync?subsystemType=1`);
            console.log("tariff data:", response.data)
            tariffEntity.value = response.data;

            return response.data;
        } catch (error) {
            console.error("Error fetching tariff:", error);
            throw error;
        } finally {
            loading.value = false;
        }
    }
    async function saveTariff(payload) {
        loading.value = true;
        try {
            const response = await apiClient.post('/Tariff', payload);

            if (response.status === 200) {
                toast.success("درخواست با موفقیت ثبت شد");
                return response.data;
            }

            toast.error("خطا در ثبت درخواست");
            console.error(response.data);
            return null;
        } catch (error) {
            console.error("Error adding tariff:", error);
            toast.error("خطا در ثبت درخواست");
            throw error;
        } finally {
            loading.value = false;
        }
    }

    return {
        tariffEntity,
        fetchtariff,
        saveTariff,
        loading
    }
})